export default __webpack_public_path__ + "static/media/OpenSans-LightItalic.0e63c9e7.ttf";